import { render } from "./MiniHeader.vue?vue&type=template&id=6212b28b&scoped=true"
import script from "./MiniHeader.vue?vue&type=script&lang=js"
export * from "./MiniHeader.vue?vue&type=script&lang=js"

import "./MiniHeader.vue?vue&type=style&index=0&id=6212b28b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6212b28b"

export default script